import React from 'react'
import Slider from 'react-slick'
import { Link } from 'react-router-dom'
import Prodect_1 from '../../../assets/images/home_page_2/product-slider/product-01.png'
import Prodect_2 from '../../../assets/images/home_page_2/product-slider/product-02.png'
import Prodect_3 from '../../../assets/images/home_page_2/product-slider/product-03.png'
import Prodect_4 from '../../../assets/images/home_page_2/product-slider/product-04.png'
import Prodect_5 from '../../../assets/images/home_page_2/product-slider/product-05.png'
import Prodect_6 from '../../../assets/images/home_page_2/product-slider/product-06.png'

const Prodectslide = {
    slidesToShow: 6,
    SlideToScroll: 1,
    Infinity: true,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 2000
}

const ProdectSlider = () => {
    return (
        <>
            <div id="product-slider-two" className="product-slider-two-main-block">
                <div className="container-fluid">
                    <Slider className="slider product-slider-two-autoplay" {...Prodectslide}>
                        <div className="product-slider-two-block">
                            <div className="item">
                                <img
                                    src={Prodect_1}
                                    className="img-fluid"
                                    alt=""
                                />
                                <div className="overlay-bg" />
                                <div className="product-slider-img-text">
                                    <h3 className="title">
                                        <Link to="/Shop" title="">
                                            Instagram
                                        </Link>
                                    </h3>
                                </div>
                            </div>
                        </div>
                        <div className="product-slider-two-block">
                            <div className="item">
                                <img
                                    src={Prodect_2}
                                    className="img-fluid"
                                    alt=""
                                />
                                <div className="overlay-bg" />
                                <div className="product-slider-img-text">
                                    <h3 className="title">
                                        <Link to="/Shop" title="">
                                            Instagram
                                        </Link>
                                    </h3>
                                </div>
                            </div>
                        </div>
                        <div className="product-slider-two-block">
                            <div className="item">
                                <img
                                    src={Prodect_3}
                                    className="img-fluid"
                                    alt=""
                                />
                                <div className="overlay-bg" />
                                <div className="product-slider-img-text">
                                    <h3 className="title">
                                        <Link to="/Shop" title="">
                                            Instagram
                                        </Link>
                                    </h3>
                                </div>
                            </div>
                        </div>
                        <div className="product-slider-two-block">
                            <div className="item">
                                <img
                                    src={Prodect_4}
                                    className="img-fluid"
                                    alt=""
                                />
                                <div className="overlay-bg" />
                                <div className="product-slider-img-text">
                                    <h3 className="title">
                                        <Link to="/Shop" title="">
                                            Instagram
                                        </Link>
                                    </h3>
                                </div>
                            </div>
                        </div>
                        <div className="product-slider-two-block">
                            <div className="item">
                                <img
                                    src={Prodect_5}
                                    className="img-fluid"
                                    alt=""
                                />
                                <div className="overlay-bg" />
                                <div className="product-slider-img-text">
                                    <h3 className="title">
                                        <Link to="/Shop" title="">
                                            Instagram
                                        </Link>
                                    </h3>
                                </div>
                            </div>
                        </div>
                        <div className="product-slider-two-block">
                            <div className="item">
                                <img
                                    src={Prodect_6}
                                    className="img-fluid"
                                    alt=""
                                />
                                <div className="overlay-bg" />
                                <div className="product-slider-img-text">
                                    <h3 className="title">
                                        <Link to="/Shop" title="">
                                            Instagram
                                        </Link>
                                    </h3>
                                </div>
                            </div>
                        </div>
                        <div className="product-slider-two-block">
                            <div className="item">
                                <img
                                    src={Prodect_1}
                                    className="img-fluid"
                                    alt=""
                                />
                                <div className="overlay-bg" />
                                <div className="product-slider-img-text">
                                    <h3 className="title">
                                        <Link to="/Shop" title="">
                                            Instagram
                                        </Link>
                                    </h3>
                                </div>
                            </div>
                        </div>
                        <div className="product-slider-two-block">
                            <div className="item">
                                <img
                                    src={Prodect_2}
                                    className="img-fluid"
                                    alt=""
                                />
                                <div className="overlay-bg" />
                                <div className="product-slider-img-text">
                                    <h3 className="title">
                                        <Link to="/Shop" title="">
                                            Instagram
                                        </Link>
                                    </h3>
                                </div>
                            </div>
                        </div>
                    </Slider>
                </div>
            </div>

        </>
    )
}

export default ProdectSlider
